import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "styles";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from "material-ui/Table";

import RaisedButton from "material-ui/RaisedButton";
import IntegratorRow from "./IntegratorRow";
import AddIntegrator from "./AddIntegrator";

export class IntegratorsTable extends Component {
  render() {
    const { integrators } = this.props;

    return (
      <div>
        <AddIntegrator></AddIntegrator>

        <div className="row" style={{ marginTop: "1rem" }}>
          <div className="table-body">
            <Table selectable={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Name of company Integrator
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Email of company
                  </TableHeaderColumn>

                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    LIST OF API
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    API LIMITS (used)
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Token
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Integrator ID
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {integrators.map((item) => (
                  <IntegratorRow key={item._id} item={item} />
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ integrators }) => ({
  integrators: integrators.data,
}))(IntegratorsTable);



// WEBPACK FOOTER //
// ./app/components/Integrators/List/Table.jsx